<template>
  <div class="upcoming-orders-by-stage-chart">
    <apexchart
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'UpcomingOrdersByStageChart',
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        xaxis: {
          categories: this.categories,
        },
        yaxis: {
          title: {
            text: '# of Orders',
          },
        },
        fill: {
          opacity: 1,
        },
        colors: ['#f54526'],
        tooltip: {
          y: {
            formatter: (val) => {
              return val + ' orders'
            },
          },
        },
      }
    },
    categories() {
      return _.map(this.data, (d) => d._id || 'Unknown')
    },
    series() {
      const values = _.map(this.data, (d) => d.count)
      return [
        {
          name: 'Orders in Progress',
          data: values,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped></style>



